var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLs14Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C16 7.47175 15.4999 5.98549 14.576 4.76814C13.6521 3.55079 12.3552 2.66924 10.8832 2.25809C9.41135 1.84694 7.84533 1.92877 6.4243 2.4911C5.00327 3.05343 3.80531 4.06535 3.01332 5.37237C2.22133 6.67939 1.87884 8.20968 2.03813 9.72961C2.19742 11.2495 2.84974 12.6756 3.89549 13.79C4.94125 14.9044 6.32298 15.646 7.82972 15.9015C9.33646 16.157 10.8854 15.9124 12.2401 15.205",
    stroke: "#80E614",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs14Px);
export default __webpack_public_path__ + "static/media/LS14px.3b1fcef8970da21de447f0ebb6de084a.svg";
export { ForwardRef as ReactComponent };